import React, { useState, useEffect } from "react";
import "../styles/ApplicationForm.css";
import { Formik, Form } from "formik"
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
// import * as Yup from "yup"
import FormPage1 from "./FormPage1";
import FormPage2 from "./FormPage2";
import FormPage1E from "./FormPage1E";
import FormPage2E from "./FormPage2E";
import FormPage3 from "./FormPage3";
import FormPage4 from "./FormPage4";
import FormPaymentPage from "./FormPaymentPage";
import { Button, Stepper, Step, StepLabel, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions} from '@material-ui/core'
import { FormValidation } from  '../models/FormValidationModel';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import {ApiURL} from '../constants/ApiUrl'
import axios from 'axios'; 
import axiosInstance from "../services/AxiosInstance";

const renderStep = (step, values, errors, touched, setFieldValue, type, id) => {
  // console.log(values,type,'0000000000')
    if(type === 'single')
    {
      switch (step) {
        case 0:
          return <FormPage1 errors={errors} touched={touched} values={values} setFieldValue={setFieldValue} appId={id}/>;
        case 1:
          return <FormPage2 errors={errors} touched={touched} values={values} setFieldValue={setFieldValue} appId={id}/>;
        case 2:
          return <FormPage3 errors={errors} touched={touched} values={values} setFieldValue={setFieldValue} appId={id}/>;
        case 3:
          return <FormPage4 errors={errors} touched={touched} values={values} setFieldValue={setFieldValue} appId={id}/>;
        case 4:
          return <FormPaymentPage errors={errors} touched={touched} values={values} setFieldValue={setFieldValue} appId={id}/>;
        default:
          return <FormPage1 errors={errors} touched={touched} values={values} setFieldValue={setFieldValue} appId={id} />;
      }
      
    }
    else if(type === 'student')
    {
      switch (step) {
        case 0:
          return <FormPage1 errors={errors} touched={touched} values={values} setFieldValue={setFieldValue} appId={id}/>;
        case 1:
          return <FormPage2 errors={errors} touched={touched} values={values} setFieldValue={setFieldValue} appId={id}/>;
        case 2:
          return <FormPage3 errors={errors} touched={touched} values={values} setFieldValue={setFieldValue} appId={id}/>;
        case 3:
          return <FormPage4 errors={errors} touched={touched} values={values} setFieldValue={setFieldValue} appId={id}/>;
        case 4:
          return <FormPaymentPage errors={errors} touched={touched} values={values} setFieldValue={setFieldValue} appId={id}/>;
        default:
          return <FormPage1 errors={errors} touched={touched} values={values} setFieldValue={setFieldValue} appId={id} />;
      }
  
    }
    else
    {
      switch (step) {
        case 0:
          return <FormPage1 errors={errors} touched={touched} values={values} setFieldValue={setFieldValue} appId={id}/>;
        case 1:
          return <FormPage2 errors={errors} touched={touched} values={values} setFieldValue={setFieldValue} appId={id}/>;
        case 2:
          return <FormPage1E errors={errors} touched={touched} values={values} setFieldValue={setFieldValue} appId={id}/>;
        case 3:
          return <FormPage2E errors={errors} touched={touched} values={values} setFieldValue={setFieldValue} appId={id}/>;
        case 4:
          return <FormPage3 errors={errors} touched={touched} values={values} setFieldValue={setFieldValue} appId={id}/>;
        case 5:
          return <FormPage4 errors={errors} touched={touched} values={values} setFieldValue={setFieldValue} appId={id}/>;
        case 6:
          return <FormPaymentPage errors={errors} touched={touched} values={values} setFieldValue={setFieldValue} appId={id}/>;
        default:
          return <FormPage1 errors={errors} touched={touched} />;
      }
    }
  };

  const getSteps = (type) => {
    if(type === '')
      return [];
    if(type === 'single')
      return ["Doctor Details", "Educational Qualifications", "Correspondence Address", "Association with NMO", "Payment Details"];
    else if(type === 'student')
      return ["Student Details", "Educational Qualifications", "Correspondence Address", "Association with NMO", "Payment Details"];
    else
      return ["Doctor Details", " Your Educational Qualifications", "Spouse Details", "Spouse Educational Qualifications",  "Correspondence Address", "Association with NMO", "Payment Details"];
  }

  const saveData = (values, type, fee, id) => {
    var temp = {
      "appId": id,
      "appType": type,
      "appFee": fee,
      "applicants": [],
      "address": {
        "line1": values.line1,
        "line2": values.line2,
        "city": values.city,
        "state": values.state,
        "pincode": values.pincode
      },
      "nmo_state": values.nmo_state,
      "prant": values.prant,
      "nmo_unit": values.nmo_unit,
      "ref_person": values.ref_person,
      "ref_membership_no": values.ref_membership_no,
      "ref_person_phone": values.ref_person_phone,
      "state_sec_email": values.state_sec_email,
        "mode": values.paymode,
        "amount": values.amount,
        "transactionId": values.transactionId
    }
    var tempapplicant1 = {
      "name": values.name,
      "dob": values.dob,
      "gender": values.gender,
      "phone": values.phone,
      "email": values.email,
      "blood_group": values.blood_group,
      "docstatus": values.docstatus,
      "degree":values.degree,
      "qualifications": values.qualifications,
      "specialization": values.specialization,
      "college": values.college,
      "regno": values.regno,
      "profile_image": values.profile_image,
      "signature_image": values.signature_image,
      "cert_image": values.cert_image
    }
    console.log(tempapplicant1,"templting...................")
    temp.applicants.push(tempapplicant1);
    console.log(temp,"ssssssss")
    console.log(tempapplicant1)
    if(type === 'couple'){
      var tempapplicant2 = {
        "name": values.name1,
        "dob": values.dob1,
        "gender": values.gender1,
        "phone": values.phone1,
        "email": values.email1,
        "blood_group": values.blood_group1,
        "docstatus": values.docstatus1,
        "qualifications": values.qualifications1,
        "specialization": values.specialization1,
        "college": values.college1,
        "regno": values.regno1,
        "profile_image": values.profile_image1,
        "signature_image": values.signature_image1,
        "cert_image": values.cert_image1
      }
      temp.applicants.push(tempapplicant2);
    }
    console.log("SAVED*********", temp);
    return temp;
  }

  const inititalData = (type) => {
    if(type === "single"){
      return {
        name: '',
        dob: '',
        gender: '',
        profile_image: '',
        blood_group: '',
        phone: 0,
        email: '',
        signature_image: '',
        docstatus: '',
        qualifications: '',
        specialization: '',
        college: '',
        regno: '',
        cert_image: '',
          line1: '',
          line2: '',
          city: '',
          state: '',
          pincode: 0,
        nmo_unit: '',
        ref_person:'',
        ref_person_phone: 0,
        ref_membership_no: '',
        state_sec_email: ''
      }
    }if(type === "student"){
      return {
        name: '',
        dob: '',
        gender: '',
        profile_image: '',
        blood_group: '',
        phone: 0,
        email: '',
        signature_image: '',
        docstatus: '',
        degree:'',
        qualifications: '',
        specialization: '',
        college: '',
        regno: '',
        cert_image: '',
          line1: '',
          line2: '',
          city: '',
          state: '',
          pincode: 0,
        nmo_unit: '',
        ref_person:'',
        ref_person_phone: 0,
        ref_membership_no: '',
        state_sec_email: ''
      }
    }
    else
    {
      return {
        name: '',
        dob: '',
        gender: '',
        profile_image: '',
        blood_group: '',
        phone: 0,
        email: '',
        signature_image: '',
        docstatus: '',
        qualifications: '',
        specialization: '',
        college: '',
        regno: '',
        cert_image: '',
        name1: '',
        dob1: '',
        gender1: '',
        profile_image1: '',
        blood_group1: '',
        phone1: 0,
        email1: '',
        signature_image1: '',
        docstatus1: '',
        
        qualifications1: '',
        specialization1: '',
        college1: '',
        regno1: '',
        cert_image1: '',
          line1: '',
          line2: '',
          city: '',
          state: '',
          pincode: 0,
        nmo_unit: '',
        ref_person:'',
        ref_person_phone: 0,
        ref_membership_no: '',
        state_sec_email: ''
      }
    }
  }


function AdminAddMem() {

    const history = useHistory();
    const dispatch = useDispatch();
    const FormDataReducer = useSelector(state => state.FormDataReducer);
    const [activeStep, setActiveStep] = useState(0);
    const [IsOpen, setIsOpen] = useState(false)
    const [IsOpen1, setIsOpen1] = useState(false)
    const steps = getSteps(FormDataReducer.appType);
    const isLastStep = activeStep === steps.length - 1;

    async function SetAllData(){
        dispatch({type: "SET_FORM_ID"});
        // const result = await axios.get(`${ApiURL}/constants/all`);
        const result = await axiosInstance.get(`${ApiURL}/constants/all`);
        dispatch({type: "SET_STATES", payload: result.data.state});
        dispatch({type: "SET_NMOSTATES", payload: result.data.nmostate});
        dispatch({type: "SET_QUAL", payload: result.data.qual});
        // console.log(FormDataReducer);
    }

    useEffect(() => {
        // console.log(FormDataReducer);
        if(FormDataReducer.appType === '' || FormDataReducer.appFee === 0){
        //   history.push('/membership')
            setIsOpen(true);
        }
        // eslint-disable-next-line
      }, [])

      async function pushData(){
        if(FormDataReducer.saved)
            return;
        // const result = await axios.post(`${ApiURL}/api/submit_application`, FormDataReducer.data);
        const result = await axiosInstance.post(`${ApiURL}/api/submit_application`, FormDataReducer.data);

        if(result.data.status === 200){
            dispatch({type: "FORM_SAVED"});
            alert('Application Submitted for Approval.');
            history.replace('/admin/dashboard');
        }
    }
    const handleSubmit = (values,actions) => {
        // console.log('Run');
        if(isLastStep)
        {
        //   formSubmit(values,actions);
            var data = saveData(values, FormDataReducer.appType, FormDataReducer.appFee, FormDataReducer.appId);
            dispatch({type: "SET_FORM_DATA", payload: data});
            setIsOpen1(true);
            actions.setSubmitting(false);
        }
        else
        {
          // console.log('Run');// setActiveStep(activeStep + 1);
          setActiveStep(activeStep+1);
          actions.setTouched({});
          actions.setSubmitting(false);
        }
      }

      const handleBack = () =>{
        setActiveStep(activeStep - 1);
      }

      const handleClose = () => {
        setIsOpen(false);
        dispatch({ type: "SET_FORM_TYPE", payload: 'single' });
        dispatch({ type: "SET_FORM_FEE", payload: 1635 });
        SetAllData();
      };
      const handleClose1 = () => {
        setIsOpen(false);
        dispatch({ type: "SET_FORM_TYPE", payload: 'couple' });
        dispatch({ type: "SET_FORM_FEE", payload: 2670 });
        SetAllData();
      };

      const handleSubApp = () => {
        pushData();
        setIsOpen1(false);
      }

      const handleNoApp = () => {
        setIsOpen1(false);
      }

    var initialValue = inititalData(FormDataReducer.appType);
    return (
        <>
                <div>
            <Stepper alternativeLabel activeStep={activeStep}>
                {steps.map((item, index) => (
                <Step key={index}>
                    <StepLabel>{item}</StepLabel>
                </Step>
                ))}
            </Stepper>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Formik initialValues={initialValue} validationSchema={FormValidation(activeStep, FormDataReducer.appType)} onSubmit={handleSubmit}>
                {(fprops)=>{
                    const {values, errors, touched, isSubmitting, setFieldValue} = fprops;
                    // console.log(fprops);
                    return (<Form>
                    {renderStep(activeStep, values,errors, touched, setFieldValue, FormDataReducer.appType, FormDataReducer.appId)}
                    
                    <div style={{textAlign: 'center', padding: '30px 0'}}>
                    {activeStep > 0 && <Button onClick={handleBack} variant="contained">Back</Button>}
                    <Button disabled={isSubmitting} type="submit" variant="contained" color="primary">{ isLastStep ? "Submit Application":"Next"}</Button>
                    </div>
                </Form>)
                }
                }
                </Formik>

            </MuiPickersUtilsProvider>
            </div>
            <Dialog open={IsOpen} >
        <DialogTitle >{"Select Application Type"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            What type of form you're fill Single Membership or Couple Membership?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Single
          </Button>
          <Button onClick={handleClose1} color="primary" >
            Couple
          </Button>
          <Button onClick={() => history.push('/admin/dashboard')} color="secondary" autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
            <Dialog open={IsOpen1} >
        <DialogTitle >{"Submit Application?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure, you want to submit application?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSubApp} color="primary">
            Yes
          </Button>
          <Button onClick={handleNoApp} color="secondary" autoFocus>
            No
          </Button>
          
        </DialogActions>
      </Dialog>
        </>
    )
}

export default AdminAddMem
